<template>
  <div class="relative w-full h-screen">
    <img
      src="../assets/img/new_bg.png"
      alt=""
      class="absolute inset-0 object-cover w-full h-full z-0"
    />
    <!-- Wrapping div with overflow-auto -->
    <div class="absolute inset-0 overflow-auto">
      <div
        class="mt-10 text-xs md:text-sm font-poppins flex flex-col items-center justify-start pt-10"
      >
        <div
          class="z-20 flex flex-col md:flex-col items-center md:items-center lg:items-center sm:flex-row gap-4 w-full px-4"
        >
          <!-- SECTION 1 -->
          <div
            class="bg-white w-full sm:w-1/2 p-5 rounded-lg shadow-lg flex flex-col items-center sm:items-start tracking-wider text-gray-700 text-[11px] md:text-[13px]"
          >
            <div class="flex justify-between items-center w-full">
              <div>
                <h1 class="font-semibold text-[13px] md:text-[14px]">
                  Personal Information
                </h1>
                <div class="w-7 h-1 bg-green-700 rounded-md mt-1"></div>
              </div>
              <router-link to="/user/system-pages">
                <div
                  class="flex items-center gap-1 w-full cursor-pointer hover:text-orange-800"
                >
                  <icon name="circle-back" />
                  <span class="text-gray-700 hover:text-orange-800">Back</span>
                </div>
              </router-link>
              <!-- <div class="bg-green-800 p-2 text-white rounded-md">
                <icon name="eye-open" />
              </div> -->
            </div>

            <div class="flex flex-col justify-center w-full">
              <div class="flex justify-center items-center relative">
                <img
                  src="../assets/img/dnsc_logo.png"
                  alt="DNSC Logo"
                  class="w-24"
                />
                <icon
                  name="edit"
                  class="absolute text-green-500 bg-white p-2 rounded-full ml-16 mt-16 hover:scale-105 duration-300 ease-in-ou transition cursor-pointer hover:border-green-500 border border-white"
                  @click="toggleUpload"
                />
              </div>
              <p class="flex justify-center mt-2">Profile</p>
            </div>

            <!-- Personal Information -->
            <div class="w-full mt-5 space-y-4">
              <div class="flex flex-col md:flex-row flexw-full gap-4">
                <div class="flex flex-col gap-2 flex-1">
                  <label class="text-gray-800 font-semibold">First Name:</label>
                  <input
                    v-model="formData.firstname"
                    type="text"
                    readonly
                    class="w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div class="flex flex-col gap-2 flex-1">
                  <label class="text-gray-800 font-semibold"
                    >Middle Name:</label
                  >
                  <input
                    v-model="formData.middlename"
                    type="text"
                    readonly
                    class="w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div class="flex flex-col gap-2 flex-1">
                  <label class="text-gray-800 font-semibold">Last Name:</label>
                  <input
                    v-model="formData.lastname"
                    type="text"
                    readonly
                    class="w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
              </div>

              <div class="flex flex-col w-full gap-4">
                <div class="flex flex-col gap-2 flex-1">
                  <label class="text-gray-800 font-semibold">Email:</label>
                  <input
                    v-model="formData.email"
                    type="text"
                    readonly
                    class="w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- SECTION 2 -->
          <!-- Change Password -->
          <div
            class="bg-white w-full sm:w-1/2 p-6 rounded-lg shadow-lg tracking-wider text-gray-700"
          >
            <div>
              <h1 class="font-semibold text-[13px] md:text-[14px]">
                Change Password
              </h1>
              <div class="w-7 h-1 bg-green-700 rounded-md mt-1"></div>
            </div>
            <div
              class="flex flex-col text-[11px] md:text-[13px] mt-5 space-y-5"
            >
              <div class="relative">
                <label class="text-gray-800 font-semibold"
                  >Current Password :</label
                >
                <input
                  v-model="currentPassword"
                  :type="showCurrentPassword ? 'text' : 'password'"
                  class="border border-gray-300 rounded-md p-2 w-full mt-2"
                  placeholder="Enter current password"
                />
                <span
                  @click="toggleCurrentPassword"
                  class="absolute right-3 top-10 cursor-pointer"
                >
                  <icon
                    :name="showCurrentPassword ? 'eye-close' : 'eye-open'"
                  />
                </span>
              </div>
              <div class="relative">
                <label class="text-gray-800 font-semibold"
                  >New Password :</label
                >
                <input
                  v-model="newPassword"
                  :type="showNewPassword ? 'text' : 'password'"
                  class="border border-gray-300 rounded-md p-2 w-full mt-2"
                  placeholder="Enter new password"
                />
                <span
                  @click="toggleNewPassword"
                  class="absolute right-3 top-10 cursor-pointer"
                >
                  <icon :name="showNewPassword ? 'eye-close' : 'eye-open'" />
                </span>
              </div>
              <div class="relative">
                <label class="text-gray-800 font-semibold"
                  >Confirm Password :</label
                >
                <input
                  v-model="confirmPassword"
                  :type="showConfirmPassword ? 'text' : 'password'"
                  class="border border-gray-300 rounded-md p-2 w-full mt-2"
                  placeholder="Enter confirmed password"
                />
                <span
                  @click="toggleConfirmPassword"
                  class="absolute right-3 top-10 cursor-pointer"
                >
                  <icon
                    :name="showConfirmPassword ? 'eye-close' : 'eye-open'"
                  />
                </span>
              </div>
            </div>
            <div class="flex justify-end mt-5">
              <button
                :disabled="!isPasswordMatch"
                class="bg-green-300 p-3 py-1 rounded-md text-green-800 hover:bg-green-800 hover:text-white text-[11px] md:text-[13px] disabled:bg-gray-300 disabled:text-gray-500"
                @click="changePassword()"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <portalSaveChangesConfirmation
    v-if="isSaveConfrimation"
    :userdetail="userdetail"
    @save="handleSave"
  />

  <div v-if="isUploadImage"><portalUploadImage /></div>

  <navigation class="fixed top-0 left-0 w-full z-50" />
</template>

<script>
import navigation from "./portal-navigation.vue";
import icon from "./icon.vue";
import portalSaveChangesConfirmation from "./alert/portal-save-changes-confirmation.vue";
import portalUploadImage from "./modals/portal-upload-image.vue";
import { toast } from "vue3-toastify";

export default {
  name: "PersonalPage",
  components: {
    navigation,
    icon,
    portalSaveChangesConfirmation,
    portalUploadImage,
  },
  data() {
    return {
      user: {
        first_name: "",
        username: "",
        password: "",
      },
      newPassword: "",
      confirmPassword: "",
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      userdetail: [],
      isUploadImage: false,
      formData: this.$store.state.user,
    };
  },
  methods: {
    handleSave(data) {
      console.log("Saved data na gikan sa portal-personal-info:", data);
      this.isSaveConfrimation = false;
    },
    toggleCurrentPassword() {
      this.showCurrentPassword = !this.showCurrentPassword;
    },
    toggleNewPassword() {
      this.showNewPassword = !this.showNewPassword;
    },
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    toggleUpload() {
      this.isUploadImage = !this.isUploadImage;
    },
    async changePassword() {
      try {
        let data = {
          email: this.$store.state.user.email,
          current_password: this.currentPassword,
          new_password: this.newPassword,
          confirm_password: this.confirmPassword,
        };

        this.axiosCall("/auth/change-password", "POST", data).then((res) => {
          if (res.data.status == 200) {
            this.isSuccess = true;
            this.message = "Password changed successfully!";
            toast.success("Password has been changed successfully!");

            // Reset form fields
            this.currentPassword = "";
            this.newPassword = "";
            this.confirmPassword = "";
            this.showCurrentPassword = false;
            this.showNewPassword = false;
            this.showConfirmPassword = false;
          } else {
            this.isSuccess = false;
            this.message = res.data.message || "Failed to change password.";
            toast.error(this.message);
          }
        });
      } catch (error) {
        this.$store.dispatch("setUser", null);
        this.isSuccess = false;

        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          this.message = error.response.data.message;
        } else {
          this.message = "Something went wrong. Please try again.";
        }

        toast.error(this.message);
        console.error(error);
      }
    },
  },
  computed: {
    isPasswordMatch() {
      return (
        this.newPassword === this.confirmPassword && this.newPassword !== ""
      );
    },
  },
  mounted() {
    console.log("User Data", this.$store.state.user);
  },
};
</script>

<style scoped>
/* Additional styles if needed */
</style>
